import service from './request'

/**
 * 获取客户列表信息
 */
 export const customerGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/customer/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户信息
 */
 export const customerGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加客户信息
 */
 export const customerAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改客户信息
 */
 export const customerUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户工单信息
 */
 export const customerGetOrderList = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/getOrderList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户变更列表信息
 */
 export const customerChangeRecGetList = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/changeRec/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除客户信息
 */
 export const customerDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户联系列表信息
 */
 export const customerContactGetList = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/contact/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 保存客户联系信息
 */
 export const customerContactSaveData = data => {
  return service({
      showLoading: false,
      url: '/crm/customer/contact/saveData',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/customerManagement.js